import { z } from 'zod'

/**
 * 關掉 zod 的 JIT。**這個模組必須是 `main.ts` 的第一個 import。**
 *
 * zod v4 建立 `z.object()` 時會先試一次 `new Function('')`，看環境准不准 eval，
 * 准的話就把 parser 編譯成一段產生出來的程式碼。我們的 CSP 是 `script-src 'self'`
 * （`nginx/snippets/security-headers.conf`），那一下會被擋 —— zod 自己接住例外、
 * 退回一般的 parser，功能沒壞，但 console 每次載入都多一條 CSP 違規，
 * 真的有人在注入腳本時那條報錯就混在噪音裡。
 *
 * 為什麼必須最先執行：偵測發生在 schema **建立**的時候，不是 parse 的時候，
 * 而 `contracts/` 底下的 schema 在模組載入時就建好了。ES module 照 import
 * 的順序深度優先執行，所以放在第一行，它就會比任何 schema 模組都早跑。
 *
 * 代價是物件 schema 的 parse 慢一點，對這個站的資料量（一次幾十筆）感覺不到。
 */
z.config({ jitless: true })
